<template>
  <div class="printBox page8 common">
    <div class="bg-t"></div>
    <div class="content">
      <div style="color: #0066CC;">
        <div style="font-size: 24px;">(三) 加强生涯规划教育</div>
      </div>
      <div>
        <div class="title">1、推动生涯规划教育</div>
        <div class="text">
          <p>将生涯规划教育纳入学生的必修课程，确保每位学生都能接受到系统的生涯 规划指导。开展生涯规划主题讲座和研讨会，邀请行业的专家和企业代表分享经验。鼓励学生参与职业体验活动，如实习、志愿服务等，帮助他们更好地了解职业世界。</p>
        </div>
      </div>
      <div>
        <div class="title">2、配备生涯规划专业指导教师</div>
        <div class="text">
          <p>招聘具有生涯规划和职业咨询背景的教师，为学生提供专业指导。定期对专业指导教师进行培训，更新他们的知识和技能。建立师生一对一咨询机制，确保每位学生都能得到个性化的生涯规划建议。</p>
        </div>
      </div>
      <div>
        <div class="title">3、建立完善就业升学指导体系</div>
        <div class="text">
          <p>建立就业和升学信息数据库，收集和整理各类招聘信息和升学途径。提供在线就业升学咨询服务，方便学生随时随地获取信息和建议。定期举办就业和升学展览会和招聘会，为学生提供与企业和院校面对面交流的机会。</p>
        </div>
      </div>
      <div>
        <div class="title">4、建立考研服务平台</div>
        <div class="text">
          <p>建立专门针对考研学生的服务平台，提供考研信息、备考指导和心理支持。定期举办考研经验分享会和模拟考试，帮助学生提高备考效率。提供考研资料和参考书籍，创建良好的学习环境。</p>
        </div>
      </div>
      <div>
        <div class="title">5、鼓励多元化就业与升学选择</div>
        <div class="text">
          <p>通过教育和宣传，引导学生认识到不同职业道路的价值和可能性。提供多元化职业路径的信息和资源，如创业、自由职业、国际就业等。鼓励学生根据自己的兴趣和能力做出灵活的选择，不局限于传统的就业和升学路径。</p>
        </div>
      </div>
    </div>
    <div class="bg-b"></div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.page8{
  position: relative;
}
.page8 .title{
  font-size: 21px;
  color: #000;
}
.page8 .text{
  font-size: 16px;
  color: #333;
}
.page8 .text p{
  text-indent: 2em;
  line-height: 2;
}
.page8 .content{
  padding: 80px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.page8 .bg-t{
  position: absolute;
  top: 0;
  right: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-rt.png") no-repeat;
  background-size: 100% 100%;
}
.page8 .bg-b{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-lb.png") no-repeat;
  background-size: 100% 100%;
}
</style>